import React, { useEffect, useState, useRef } from 'react';
import { Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import './ModalCrearUsuario.css';

function ModalValidacionServicioPlanilla({ isOpen, row, onClose, onSave }) {
  const [archivo, setArchivo] = useState(null);
  const fileRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    setArchivo(null);
    if (fileRef.current) fileRef.current.value = '';
  }, [isOpen]);

  const handleSubmit = async () => {
    if (!archivo) return alert('Seleccione un archivo PDF.');
    try {
      await onSave({ id: row.id, archivo });
      onClose(true);
    } catch {
    }
  };

  return (
    <Modal isOpen={isOpen} fade={false} className="custom-modal" backdrop="static" size="md">
      <ModalHeader className="modal-header">
        <div className="titulo">
          <h1>SUBIR PLANILLA</h1>
          <Button className="close-btn" onClick={() => onClose(false)}>
            X
          </Button>
        </div>
      </ModalHeader>
      <div className="modal-body-footer">
        <ModalBody className="modal-body p-4">
          <Form onSubmit={(e) => e.preventDefault()} className="px-4 mt-2">
            <FormGroup>
              <Label>Colaborador</Label>
              <Input type="text" value={row?.nombre_usuario || ''} disabled />
            </FormGroup>
            <FormGroup className="mb-4">
              <Label>Planilla (PDF):</Label>
              <div className="cap-upload-zone">
                <span className="cap-upload-btn" onClick={() => fileRef.current?.click()}>
                  {archivo ? archivo.name : 'Seleccionar archivo (PDF)'}
                </span>
                <input
                  ref={fileRef}
                  type="file"
                  accept=".pdf"
                  style={{ display: 'none' }}
                  onChange={(e) => setArchivo(e.target.files?.[0] || null)}
                />
              </div>
              {archivo && (
                <small>
                  <span
                    style={{ cursor: 'pointer', color: '#f87171', fontSize: '10px' }}
                    onClick={() => {
                      setArchivo(null);
                      if (fileRef.current) fileRef.current.value = '';
                    }}
                  >
                    ✕ Quitar selección
                  </span>
                </small>
              )}
              {row?.tiene_planilla === 1 && row?.url_planilla_publica && !archivo && (
                <small className="text-success mt-1 d-block">
                  ✓ Ya existe una planilla subida.{' '}
                  <span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => window.open(row.url_planilla_publica, '_blank')}>Ver documento</span>
                </small>
              )}
            </FormGroup>
            
            <div className="flex justify-end mt-4 pb-3">
              <Button 
                className="btn-primary px-5 py-2" 
                onClick={handleSubmit}
                style={{ borderRadius: '8px' }}
              >
                GUARDAR
              </Button>
            </div>
          </Form>
        </ModalBody>
      </div>
    </Modal>
  );
}

export default ModalValidacionServicioPlanilla;
